





















import { Vue, Component } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import { User } from "@/types";

@Component
export default class UserSideMenu extends Vue {
  @Action("logout") logout!: Function;
  @State("user") user!: User;

  get initials() {
    const id = (this.user && this.user.email) || "";
    return id.slice(0, 2);
  }
}
